import { pages } from '@microsoft/teams-js';
import React, { useEffect, useState } from 'react';

import * as S from './TabConfig.styles';

type TabSelection = 'alfred' | 'insights';

export const TabConfig = () => {
  const [selectedTab, setSelectedTab] = useState<TabSelection>('alfred');

  useEffect(() => {
    pages.config.registerOnSaveHandler(async saveEvent => {
      const contentUrl = `${window.location.origin}/app/${selectedTab}`;

      try {
        await pages.config.setConfig({
          suggestedDisplayName: 'Reflexivity',
          entityId: `reflexivity-${selectedTab}`,
          contentUrl,
          websiteUrl: contentUrl,
        });
        saveEvent.notifySuccess();
      } catch {
        saveEvent.notifyFailure('Failed to save tab configuration');
      }
    });

    pages.config.setValidityState(true);
  }, [selectedTab]);

  return (
    <S.Wrapper>
      <S.Title>Configure Reflexivity Tab</S.Title>
      <S.Description>Choose which view to show in this tab.</S.Description>
      <S.OptionList>
        <S.Option
          $isSelected={selectedTab === 'alfred'}
          onClick={() => setSelectedTab('alfred')}
        >
          <S.OptionTitle>Alfred</S.OptionTitle>
          <S.OptionDescription>
            AI-powered research and analysis assistant
          </S.OptionDescription>
        </S.Option>
        <S.Option
          $isSelected={selectedTab === 'insights'}
          onClick={() => setSelectedTab('insights')}
        >
          <S.OptionTitle>Insights</S.OptionTitle>
          <S.OptionDescription>
            Explore market themes and investment insights
          </S.OptionDescription>
        </S.Option>
      </S.OptionList>
    </S.Wrapper>
  );
};
